/** Короткий фрагмент текста для карточек и шапки (описание может прийти с HTML из CRM). */
export function plainTextSnippet(raw: string | null | undefined, maxLen: number): string {
  const s = (raw ?? '').trim();
  if (!s) return '';
  const plain = s.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  if (plain.length <= maxLen) return plain;
  return `${plain.slice(0, maxLen).trim()}…`;
}
